export default __webpack_public_path__ + "74e93359fe237922c384fae98b462ff2.png";